export default __webpack_public_path__ + "static/media/content-deco-1.b2fafe7c.webp";